import {IconType} from '../Icon/IconType.enum';
import {INTERNAL_STATIC_IMAGE_INFO_MAP} from './InternalStaticImageInfoMap.constant';
import {InternalStaticImageType} from './InternalStaticImageType.enum';
import {StaticImageInfo} from './StaticImageInfo.interface';
import {StaticImageType} from './StaticImageType.enum';

export const STATIC_IMAGE_INFO_MAP: {
  [key in
    | IconType
    | StaticImageType
    | InternalStaticImageType]: StaticImageInfo;
} = {
  ...INTERNAL_STATIC_IMAGE_INFO_MAP,
  /**
   * Image 타입
   */
  [StaticImageType.PolicyRight01]: {
    srcDark: 'img_policyright_01_dark.svg',
    srcLight: 'img_policyright_01.svg',
    alt: '권리침해신고 처리 절차 1',
    width: 330,
    height: 199,
  },
  [StaticImageType.PolicyRight02]: {
    srcDark: 'img_policyright_02_dark.svg',
    srcLight: 'img_policyright_02.svg',
    alt: '권리침해신고 처리 절차 2',
    width: 330,
    height: 203,
  },
  [StaticImageType.ProfileStatic]: {
    srcStatic: 'img_profile_static.svg',
    alt: '프로필',
    width: 96,
    height: 96,
  },
  [StaticImageType.ProfileDormantStatic]: {
    srcStatic: 'img_profile_dormant_static.svg',
    alt: '프로필',
    width: 96,
    height: 96,
  },
  [StaticImageType.ProfileWithdrawalStatic]: {
    srcStatic: 'img_profile_withdrawal_static.svg',
    alt: '프로필',
    width: 96,
    height: 96,
  },
  [StaticImageType.Thumbnail19PosterStatic]: {
    srcStatic: 'img_thumbnail_19_poster_static.svg',
    alt: '19세',
    width: 108,
    height: 154,
  },
  [StaticImageType.Thumbnail19CardStatic]: {
    srcStatic: 'img_thumbnail_19_card_static.svg',
    alt: '19세',
    width: 118,
    height: 236,
  },
  [StaticImageType.TooltipTailLeftStatic]: {
    srcStatic: 'img_tooltip_tail_left_static.svg',
    alt: '툴팁',
    width: 12,
    height: 12,
  },
  [StaticImageType.TooltipTailRightStatic]: {
    srcStatic: 'img_tooltip_tail_right_static.svg',
    alt: '툴팁',
    width: 12,
    height: 12,
  },
  [StaticImageType.TooltipTailDownStatic]: {
    srcStatic: 'img_tooltip_tail_down_static.svg',
    alt: '툴팁',
    width: 12,
    height: 12,
  },
  [StaticImageType.TooltipTailUpStatic]: {
    srcStatic: 'img_tooltip_tail_up_static.svg',
    alt: '툴팁',
    width: 12,
    height: 12,
  },
  [StaticImageType.TooltipMoreTailDownStatic]: {
    srcStatic: 'img_tooltip_more_tail_down_static.svg',
    alt: '툴팁',
    width: 16,
    height: 16,
  },
  [StaticImageType.LogoBiTextL]: {
    srcDark: 'img_logo_bi_text_l_dark.svg',
    srcLight: 'img_logo_bi_text_l.svg',
    alt: '카카오페이지 로고',
    width: 110,
    height: 24,
  },
  [StaticImageType.LogoBiTextM]: {
    srcDark: 'img_logo_bi_text_m_dark.svg',
    srcLight: 'img_logo_bi_text_m.svg',
    alt: '카카오페이지 로고',
    width: 80,
    height: 24,
  },
  [StaticImageType.FooterCopyright]: {
    srcDark: 'img_footer_copyright_dark.svg',
    srcLight: 'img_footer_copyright.svg',
    alt: '카피라이트',
    width: 156,
    height: 12,
  },
  [StaticImageType.FooterMycelebs]: {
    srcDark: 'img_footer_mycelebs_dark.svg',
    srcLight: 'img_footer_mycelebs.svg',
    alt: '마이셀럽스 로고',
    width: 131,
    height: 16,
  },
  [StaticImageType.GiftStatic]: {
    srcStatic: 'img_gift_static@2x.png',
    alt: '선물',
    width: 720,
    height: 464,
  },
  [StaticImageType.NotificationBiStatic]: {
    srcStatic: 'img_notification_bi_static.svg',
    alt: '로고',
    width: 56,
    height: 56,
  },
  [StaticImageType.NotificationCashStatic]: {
    srcStatic: 'img_notification_cash_static.png',
    alt: '캐시',
    width: 168,
    height: 169,
  },
  [StaticImageType.NotificationGiftStatic]: {
    srcStatic: 'img_notification_gift_static.png',
    alt: '선물',
    width: 168,
    height: 169,
  },
  [StaticImageType.NotificationHeartStatic]: {
    srcStatic: 'img_notification_heart_static.png',
    alt: '선물',
    width: 168,
    height: 169,
  },
  [StaticImageType.NotificationCommentStatic]: {
    srcStatic: 'img_notification_comment_static.svg',
    alt: '댓글',
    width: 56,
    height: 56,
  },
  [StaticImageType.ViewerTutorialEpub01Static]: {
    srcStatic: 'img_viewer_tutorial_epub01_static.svg',
    alt: '이펍 뷰어 가이드',
    width: 360,
    height: 440,
  },
  [StaticImageType.ViewerTutorialEpub02Static]: {
    srcStatic: 'img_viewer_tutorial_epub02_static.svg',
    alt: '이펍 뷰어 가이드',
    width: 360,
    height: 440,
  },
  [StaticImageType.ViewerTutorialImage01Static]: {
    srcStatic: 'img_viewer_tutorial_image01_static.svg',
    alt: '이미지 뷰어 가이드',
    width: 360,
    height: 440,
  },
  [StaticImageType.ViewerTutorialImage02Static]: {
    srcStatic: 'img_viewer_tutorial_image02_static.svg',
    alt: '이미지 뷰어 가이드',
    width: 360,
    height: 440,
  },
  [StaticImageType.ViewerTutorialTalk01Static]: {
    srcStatic: 'img_viewer_tutorial_talk01_static.svg',
    alt: '톡뷰어 가이드',
    width: 360,
    height: 440,
  },
  [StaticImageType.ViewerTutorialTalk02Static]: {
    srcStatic: 'img_viewer_tutorial_talk02_static.svg',
    alt: '톡뷰어 가이드',
    width: 360,
    height: 440,
  },
  [StaticImageType.PaymentPopularStatic]: {
    srcStatic: 'img_payment_popular_static.svg',
    alt: '인기',
    width: 40,
    height: 20,
  },
  [StaticImageType.PaymentAll]: {
    srcDark: 'img_payment_all_dark.svg',
    srcLight: 'img_payment_all.svg',
    alt: '전체',
    width: 40,
    height: 20,
  },
  [StaticImageType.CouponCashFriendsStatic]: {
    srcStatic: 'img_coupon_cash_friends_static.svg',
    alt: '캐시프렌즈',
    width: 360,
    height: 70,
  },
  [StaticImageType.CouponTvPointStatic]: {
    srcStatic: 'img_coupon_tv_point_static.svg',
    alt: 'tv포인트',
    width: 360,
    height: 70,
  },
  [StaticImageType.CouponHistoryStatic]: {
    srcStatic: 'img_coupon_gift_static@2x.png',
    alt: '쿠폰',
    width: 72,
    height: 80,
  },
  [StaticImageType.Coupon72h]: {
    srcDark: 'img_coupon_72h_dark.svg',
    srcLight: 'img_coupon_72h.svg',
    alt: '72시간',
    width: 42,
    height: 42,
  },
  [StaticImageType.CrmCashStatic]: {
    srcStatic: 'img_crm_cash_static.svg',
    alt: '캐시',
    width: 40,
    height: 48,
  },
  [StaticImageType.CrmGiftStatic]: {
    srcStatic: 'img_crm_gift_static.svg',
    alt: '선물',
    width: 40,
    height: 48,
  },
  [StaticImageType.CrmWelcomeStatic]: {
    srcStatic: 'img_crm_welcome_web_static@2x.png',
    alt: '웰컴',
    width: 720,
    height: 484,
  },
  [StaticImageType.CashPassVipUnsubcribeStatic]: {
    srcStatic: 'img_cash_pass_vip_unsubscribe_static.svg',
    alt: '구독해제',
    width: 108,
    height: 118,
  },
  [StaticImageType.CashPassVipCashStatic]: {
    srcStatic: 'img_cash_pass_vip_cash_static.svg',
    alt: '현금',
    width: 188,
    height: 160,
  },
  [StaticImageType.CashPassVipCardStatic]: {
    srcStatic: 'img_cash_pass_vip_card_static.svg',
    alt: '카드',
    width: 237,
    height: 186,
  },
  [StaticImageType.CashPassVipDimStatic]: {
    srcStatic: 'img_cash_pass_vip_dim_static.svg',
    alt: '가림막',
    width: 360,
    height: 200,
  },
  [StaticImageType.CashPassVipTextStatic]: {
    srcStatic: 'img_cash_pass_vip_text_static.svg',
    alt: '문구',
    width: 227,
    height: 87,
  },
  [StaticImageType.CashPassVipComplete]: {
    srcStatic: 'img_cash_pass_vip_complete.svg',
    alt: '완료',
    width: 50,
    height: 50,
  },
  [StaticImageType.ExceptionNoticeMStatic]: {
    srcStatic: 'img_exception_notice_m_static.svg',
    alt: '안내',
    width: 70,
    height: 70,
  },
  [StaticImageType.ExceptionBiMStatic]: {
    srcStatic: 'img_exception_bi_m_static.svg',
    alt: '로고',
    width: 70,
    height: 70,
  },
  [StaticImageType.ExceptionNoticeLStatic]: {
    srcStatic: 'img_exception_notice_l_static.svg',
    alt: '안내',
    width: 90,
    height: 90,
  },
  [StaticImageType.ExceptionBiLStatic]: {
    srcStatic: 'img_exception_bi_l_static.svg',
    alt: '로고',
    width: 100,
    height: 100,
  },
  [StaticImageType.Age15Static]: {
    srcStatic: 'img_age15_static.svg',
    alt: '15세',
    width: 90,
    height: 90,
  },
  [StaticImageType.Age19Static]: {
    srcStatic: 'img_age19_static.svg',
    alt: '19세',
    width: 90,
    height: 90,
  },
  // 네이밍 뒤에 43은 1:1.43 비율을 적었습니다.
  [StaticImageType.Age19Thumbnail43]: {
    srcStatic: 'img_age_19_Thumbnail_43.png',
    alt: '19세',
    width: 108,
    height: 154,
  },
  // 네이밍 뒤에 2은 1:2 비율을 적었습니다.
  [StaticImageType.Age19Thumbnail2]: {
    srcStatic: 'img_age_19_Thumbnail_2.png',
    alt: '19세 뱃지',
    width: 118,
    height: 236,
  },
  [StaticImageType.InstallPc]: {
    srcStatic: 'img_install_banner_pc_static@2x.png',
    alt: 'pc 앱 다운로드',
    width: 1556,
    height: 220,
  },
  [StaticImageType.InstallBannerDaMw]: {
    srcStatic: 'img_install_banner_da_mw_static@2x.png',
    alt: '디스플레이 앱 설치 배너',
    width: 630,
    height: 136,
  },
  [StaticImageType.InstallBannerViewerEndMw]: {
    srcStatic: 'img_install_banner_viewer_end_mw_static@2x.png',
    alt: '디스플레이 앱 설치 배너',
    width: 856,
    height: 428,
  },
  [StaticImageType.InstallMw]: {
    srcStatic: 'img_install_banner_mw_static@2x.png',
    alt: '모바일 앱 다운로드',
    width: 660,
    height: 220,
  },
  [StaticImageType.AppStore]: {
    srcStatic: 'img_install_banner_appstore_pc_static.svg',
    alt: '앱 스토어',
    width: 108,
    height: 32,
  },
  [StaticImageType.PlayStore]: {
    srcStatic: 'img_install_banner_googleplay_pc_static.svg',
    alt: '플레이 스토어',
    width: 108,
    height: 32,
  },
  [StaticImageType.BillingCheckOff]: {
    srcStatic: 'billing-check-off.png',
    alt: '체크 비활성',
    width: 30,
    height: 30,
  },
  [StaticImageType.BillingCheckOn]: {
    srcStatic: 'billing-check-on.png',
    alt: '체크 활성',
    width: 30,
    height: 30,
  },
  [StaticImageType.AppSchemeGoogleplayPcStatic]: {
    srcStatic: 'img_app_scheme_googleplay_pc_static.svg',
    alt: '구글 플레이',
    width: 168,
    height: 48,
  },
  [StaticImageType.AppSchemeAppstorePcStatic]: {
    srcStatic: 'img_app_scheme_appstore_pc_static.svg',
    alt: '앱스토어',
    width: 168,
    height: 48,
  },
  [StaticImageType.AppSchemeQrLocal]: {
    srcStatic: 'img_app_scheme_qr_dev.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrDev]: {
    srcStatic: 'img_app_scheme_qr_dev.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrTest]: {
    srcStatic: 'img_app_scheme_qr_dev.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrAlpha]: {
    srcStatic: 'img_app_scheme_qr_alpha.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrSandbox]: {
    srcStatic: 'img_app_scheme_qr_sandbox.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrQa]: {
    srcStatic: 'img_app_scheme_qr_qa.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrBeta]: {
    srcStatic: 'img_app_scheme_qr_beta.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.AppSchemeQrReal]: {
    srcStatic: 'img_app_scheme_qr_real.svg',
    alt: 'qr',
    width: 88,
    height: 88,
  },
  [StaticImageType.DabannerCashfriendsStatic]: {
    srcStatic: 'img_dabanner_cashfriends_static.svg',
    alt: '캐시프렌즈',
    width: 300,
    height: 65,
  },
  [StaticImageType.ExpandCashfriendsStatic]: {
    srcStatic: 'img_expand_cashfriends_static.svg',
    alt: '캐시프렌즈',
    width: 428,
    height: 214,
  },
  [StaticImageType.ModalGiftStatic]: {
    srcStatic: 'img_modal_gift_static.svg',
    alt: '선물',
    width: 108,
    height: 108,
  },
  [StaticImageType.ModalCashStatic]: {
    srcStatic: 'img_modal_cash_static.svg',
    alt: '캐시',
    width: 108,
    height: 108,
  },
  [StaticImageType.ModalAppIconStatic]: {
    srcStatic: 'img_modal_appicon_static.svg',
    alt: '카카오페이지',
    width: 108,
    height: 108,
  },
  [StaticImageType.LogoBiStatic]: {
    srcStatic: 'img_logo_bi_l_mw_static.svg',
    alt: '카카오페이지',
    width: 96,
    height: 96,
  },
  [StaticImageType.HelixLandingBgV1Static]: {
    srcStatic: 'helix_img_landing_bg_v1.png',
    alt: '헬릭스 랜딩',
    width: 720,
    height: 480,
  },
  [StaticImageType.HelixLandingBgStatic]: {
    srcStatic: 'helix_img_landing_bg.png',
    alt: '헬릭스 랜딩',
    width: 480,
    height: 400,
  },
  [StaticImageType.ThumbnailEmptyCardStatic]: {
    srcStatic: 'img_thumbnail_emptycard_static.png',
    alt: '빈 카드',
    width: 600,
    height: 1200,
  },
};
